"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var i0 = require("./conversation.component.scss.shim.ngstyle");
var i1 = require("@angular/core");
var i2 = require("../../components/chat/chat.component.ngfactory");
var i3 = require("../../components/chat/chat.component");
var i4 = require("../../../Services/service.service");
var i5 = require("@angular/router");
var i6 = require("../../../Services/conversationService");
var i7 = require("./conversation.component");
var styles_ConversationComponent = [i0.styles];
var RenderType_ConversationComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_ConversationComponent, data: {} });
exports.RenderType_ConversationComponent = RenderType_ConversationComponent;
function View_ConversationComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 2, "div", [["class", "conversationView"]], null, null, null, null, null)), (_l()(), i1.ɵeld(1, 0, null, null, 1, "vng-chat", [["class", "w-100"]], null, [["window", "popstate"]], function (_v, en, $event) { var ad = true; if (("window:popstate" === en)) {
        var pd_0 = (i1.ɵnov(_v, 2).onPopState($event) !== false);
        ad = (pd_0 && ad);
    } return ad; }, i2.View_ChatComponent_0, i2.RenderType_ChatComponent)), i1.ɵdid(2, 114688, null, 0, i3.ChatComponent, [i4.MainService, i5.ActivatedRoute, i6.ConversationService], null, null)], function (_ck, _v) { _ck(_v, 2, 0); }, null); }
exports.View_ConversationComponent_0 = View_ConversationComponent_0;
function View_ConversationComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-conversation", [], null, null, null, View_ConversationComponent_0, RenderType_ConversationComponent)), i1.ɵdid(1, 114688, null, 0, i7.ConversationComponent, [i4.MainService, i5.ActivatedRoute], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
exports.View_ConversationComponent_Host_0 = View_ConversationComponent_Host_0;
var ConversationComponentNgFactory = i1.ɵccf("app-conversation", i7.ConversationComponent, View_ConversationComponent_Host_0, {}, {}, []);
exports.ConversationComponentNgFactory = ConversationComponentNgFactory;
